import { render, staticRenderFns } from "./game-member-rounds.vue?vue&type=template&id=31b58f4e&scoped=true"
import script from "./game-member-rounds.vue?vue&type=script&lang=js"
export * from "./game-member-rounds.vue?vue&type=script&lang=js"
import style0 from "./game-member-rounds.vue?vue&type=style&index=0&id=31b58f4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b58f4e",
  null
  
)

export default component.exports